import React from "react";
import * as Yup from "yup";
import PauseIcon from "@material-ui/icons/Pause";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import StopIcon from "@material-ui/icons/Stop";
import store from "../../Redux/Store";

let addnewSteps = {};

export const addStepState = newState => {
  addnewSteps = newState;
};
export const getNewState = () => {
  return addnewSteps;
};

export const addCampaignForm = {
  title: "AddCampaignForm",
  onSubmit: args => {},
  fields: [
    {
      label: "Customer",
      type: "dynamicSelect",
      name: "customerid",
      value: "Select Customer",
      placeholder: "Select Customer",
      isRequired: true,
      data: "params",
      key1: "company"
    },
    {
      label: "LinkedIn Profile",
      type: "dynamicSelect",
      name: "linkedinid",
      value: "Select LinkedIn Profile",
      placeholder: "Select LinkedIn Profile",
      isRequired: true,
      key1: "name"
    },
    {
      label: "Campaign Name",
      type: "input",
      placeholder: "Enter Campaign Name",
      isRequired: true,
      name: "name",
      value: ""
    },
    {
      label: "Campaign Manager",
      type: "dynamicSelect",
      name: "campaignmanagerid",
      value: "Select Campaign Manager",
      placeholder: "Select Campaign Manager",
      isRequired: true,
      data: "params1",
      key1: "firstName",
      key2: "lastName"
    },
    {
      label: "Campaign Description",
      type: "textarea",
      placeholder: "Enter Campaign Description",
      name: "description",
      value: ""
    },
    {
      label: "Start Date",
      type: "datepicker",
      name: "startdate",
      placeholder: "mm/dd/yyyy",
      minDate: new Date(),
      required: true,
      value: ""
    },
    {
      label: "Start Time",
      type: "timepicker",
      name: "starttime",
      placeholder: "hh:mm",
      required: true,
      value: ""
    },
    // {
    //   label: "Time Zone",
    //   type: "staticSelect",
    //   name: "timezone",
    //   value: "Select Timezone",
    //   isRequired: true,
    //   placeholder: "Select Timezone",
    //   data: [
    //     { name: "PST (-8:00)", value: "-28800" },
    //     { name: "MST/PDT (-7:00)", value: "-25200" },
    //     { name: "CST/MDT (-6:00)", value: "-21600" },
    //     { name: "EST/CDT (-5:00)", value: "-18000" },
    //     { name: "EDT (-4:00)", value: "-14400" },
    //     { name: "GMT (0:00)", value: "0" },
    //     { name: "BST (+1:00)", value: "+3600" },
    //     { name: "IST (+5:30)", value: "+19800" }
    //   ]
    // },
    {
      label: "Campaign Target",
      type: "input",
      placeholder: "e.g. 100",
      name: "targetconnections",
      isRequired: true,
      value: ""
    },
    {
      label: "Use Sales Navigator",
      type: "checkbox",
      name: "salesNavigator",
      value: true
    },
    {
      label: "Workflow",
      type: "heading"
    },
   
    {
      type: "label"
    }
  ]
};

export const CampaignModalConfig = {
  title: "Add Step",

  fields: [
    {
      label: "Step",
      type: "staticSelect",
      name: "stepname",
      isRequired: true,
      value: "Select",
      placeholder: "Select",
      data: [
        { name: "Visit Profile", value: "VISIT" },
        { name: "Follow Profile", value: "FOLLOW" },
        { name: "Send Invite", value: "SEND_INVITE" },
        { name: "Send Thanks Message", value: "SEND_THANKS_MESSAGE" },
        { name: "Send Message", value: "SEND_MESSAGE" },
        { name: "Inmail Message", value: "INMAIL_MESSAGE" }
      ],
      active: true
    },
    {
      label: "Limit Per Day",
      type: "input",
      placeholder: "e.g. 100",
      isRequired: true,
      name: "limitperday",
      value: ""
    },
    {
      label: "Max Limit ",
      type: "note",
      name: "note message",
      value: ""
    },
    {
      label: "Delay (days)",
      type: "dynamicInput",
      placeholder: "e.g. 2",
      isRequired: true,
      name: "daysdelay",
      value: ""
    },
    {
      type: "list",
      name: "list",
      data: [
        "First Name",
        "Last Name",
        "D.O.B",
        "First Name",
        "Last Name",
        "D.O.B",
        "First Name",
        "Last Name",
        "D.O.B"
      ]
    },
    {
      label: "Message",
      type: "messageArea",
      placeholder: "Compose message here...",
      isRequired: true,
      rows: "6",
      column: "10",
      name: "message",
      value: ""
    },
    {
      label: "Personal Note",
      type: "personalNote",
      placeholder: "Compose Personal Note here...",
      rows: "6",
      column: "10",
      name: "personalmessage",
      value: ""
    },
    {
      label: "Thanks Message",
      type: "thanksMessageArea",
      placeholder: "Compose thanks message here...",
      isRequired: true,
      rows: "6",
      column: "10",
      name: "replyMessage",
      value: ""
    },
    {
      label: "Thanks Message",
      type: "thanksMessageArea2",
      placeholder: "Compose thanks message here...",
      isRequired: true,
      rows: "6",
      column: "10",
      name: "replyInmailMessage",
      value: ""
    }
  ]
};

export const editCampaignForm = {
  title: "Edit Campaign",
  fields: [
    {
      label: "Customer",
      type: "dynamicSelect",
      name: "customerid",
      value: "Select Customer",
      data: "params",
      key1: "company",
      isRequired: true,
      placeholder: "Select Customer",
      active: true
    },
    {
      label: "LinkedIn Profile",
      type: "dynamicSelect",
      name: "linkedinid",
      value: "Select LinkedIn Profile",
      key1: "name",
      isRequired: true,
      placeholder: "Select LinkedIn Profile",
      link: true
    },
    {
      label: "Campaign Name",
      type: "input",
      placeholder: "Enter Campaign Name",
      isRequired: true,
      name: "name",
      value: ""
    },
    {
      label: "Campaign Manager",
      type: "dynamicSelect",
      name: "campaignmanagerid",
      value: "Select Campaign Manager",
      placeholder: "Select Campaign Manager",
      isRequired: true,
      data: "params1",
      key1: "firstName",
      key2: "lastName"
    },
    {
      label: "Campaign Description",
      type: "textarea",
      placeholder: "Enter Campaign Description",
      name: "description",
      value: ""
    },


    {
      label: "Start Date",
      type: "datepicker",
      name: "startdate",
      disabled: true,
      placeholder: "mm/dd/yyyy",
      required: true,
      // disablePast: true,
      minDate: new Date(),
      value: ""
    },
    {
      label: "Start Time",
      type: "timepicker",
      name: "starttime",
      placeholder: "hh:mm",
      disabled: true,
      required: true,
      value: ""
    },
    // {
    //   label: "Time Zone",
    //   type: "staticSelect",
    //   name: "timezone",
    //   value: "Select Timezone",
    //   isRequired: true,
    //   placeholder: "Select Timezone",
    //   data: [
    //     { name: "PST (-8:00)", value: "-28800" },
    //     { name: "MST/PDT (-7:00)", value: "-25200" },
    //     { name: "CST/MDT (-6:00)", value: "-21600" },
    //     { name: "EST/CDT (-5:00)", value: "-18000" },
    //     { name: "EDT (-4:00)", value: "-14400" },
     
    //     { name: "GMT (0:00)", value: "0" },
    //     { name: "BST (+1:00)", value: "+3600" },
    //     { name: "IST (+5:30)", value: "+19800" }
    //   ]
    // },
    {
      label: "Campaign Target",
      type: "input",
      placeholder: "e.g. 100",
      name: "targetconnections",
      isRequired: true,
      value: ""
    },
    {
      label: "button",
      type: "button",
      name: "button",
      color: "Primary",
      size: "medium",
      disabled: true,
      buttontext: "Live",
      iconname: <PlayArrowIcon />,
      value: "",
      funName: "setLiveStatus"
    },
    {
      label: "button",
      type: "button",
      name: "button",
      color: "Primary",
      size: "medium",
      buttontext: "Pause",
      action: true,
      iconname: <PauseIcon />,
      value: "",
      funName: "setPauseStatus"
    },
    {
      label: "button",
      type: "button",
      name: "button",
      color: "secondary",
      size: "medium",
      buttontext: "End",
      iconname: <StopIcon />,
      value: "",
      funName: "setEndStatus"
    },
    {
      label: "button",
      type: "button",
      name: "button",
      color: "secondary",
      size: "medium",
      delete: true,
      buttontext: "Delete",
      iconname: <StopIcon />,
      value: "",
      funName: "setDeleteStatus"
    },
    {
      label: "Use Sales Navigator",
      type: "checkbox",
      name: "salesNavigator",
      value: ""
    },
    {
      label: "Workflow",
      type: "heading"
    },

    {
      type: "label"
    }
  ]
};

export const campaignValidation = Yup.object().shape({
  name: Yup.string()
    .required("Please enter campaign name")
    // .min(1, "Please enter a Campaign Name")
    .max(50, "Campaign name should be less than 50 characters")
    .matches(/[A-Za-z0-9]/, {
      message: "Please enter valid campaign name",
      excludeEmptyString: true
    }),

  description: Yup.string()
    .matches(/[A-Za-z0-9]/, {
      message: "Please enter a valid campaign description",
      excludeEmptyString: true
    })
    .max(250, "Campaign description should be less than 250 characters"),

  targetconnections: Yup.string()
    .matches(/^\d+$/, {
      message: "Only numbers allowed",
      excludeEmptyString: true
    })
    .test(
      "value not zero",
      "Connections should be greater than zero.",
      value => {
        return value !== 0;
      }
    )
    .max(10, "Connections should be less than 10 digits")
    .required("Please enter connections"),

  customerid: Yup.string()
    .ensure()
    .test("customerid", "Please select customer", value => {
      return value !=="Select Customer";
    }),

  linkedinid: Yup.string()
    .ensure()
    .test("customerid", "Please select Linkedin profile", value => {
      return value !== "Select LinkedIn Profile";
    }),

  campaignmanagerid: Yup.string()
    .ensure()
    .test("customerid", "Please select campaign manager", value => {
      return value !== "Select Campaign Manager";
    }),

  // timezone: Yup.string()
  //   .ensure()
  //   .test("customerid", "Please select time zone", value => {
  //     return value !== "Select Timezone";
  //   })
});

export const editcampaignValidation = Yup.object().shape({
  name: Yup.string()
    .required("Please enter campaign name")
   
    .max(50, "Campaign name should be less than 50 characters")
    .matches(/[A-Za-z0-9]/, {
      message: "Please enter valid campaign name",
      excludeEmptyString: true
    }),

  description: Yup.string()
    .matches(/[A-Za-z0-9]/, {
      message: "Please enter valid campaign description",
      excludeEmptyString: true
    })
    .max(250, "Campaign description should be less than 250 characters"),

  targetconnections: Yup.string()
    .matches(/^\d+$/, {
      message: "Only numbers allowed",
      excludeEmptyString: true
    })
    .test("required connection", "Please enter connections", value => {
      return !!value === true;
    })
    .test(
      "value not zero",
      "Connections should be greater than zero.",
      value => {
        return value !== 0;
      }
    )
    .test(
      "target Connection Value",
      "Connection value should be greater than current value",
      value => {
        return value >= store.getState().formData.targetconnections;
      }
    )
    .max(10, "Connections should be less than 10 digits"),
 

  customerid: Yup.string()
    .ensure()
    .test("customerid", "Please select customer", value => {
      return value !== "Select Customer";
    }),

  linkedinid: Yup.string()
    .ensure()
    .test("customerid", "Please select Linkedin profile", value => {
      return value !== "Select LinkedIn Profile";
    }),

  campaignmanagerid: Yup.string()
    .ensure()
    .test("customerid", "Please select campaign manager", value => {
      return value !== "Select Campaign Manager";
    }),

  // timezone: Yup.string()
  //   .ensure()
  //   .test("customerid", "Please select time zone", value => {
  //     return value !== "Select Timezone";
  //   })
});
